var map = {
	"./Cooling-black.png": 57114,
	"./Freeze-black.png": 3954,
	"./Heating-black.png": 63761,
	"./Leaks-black.png": 85363,
	"./Runtime-black.png": 93363,
	"./Space-black.png": 16129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41884;